module.exports = __webpack_public_path__ + "img/unisms.logo@2x.8abba771.png";